import {
    FETCH_TAG_SUCCESS,
    FETCH_TAG_ERROR,
    FETCH_TAG_LOADING
} from "./index" 

import {apiCall} from "../../functions/utils"

export const fetchTagSuccess = (data) => {
    return {
        type : FETCH_TAG_SUCCESS,
        payload: data.data
    }
}

export const fetchTagError = (error) => {
    return {
        type : FETCH_TAG_ERROR,
        error
    }
}

export const fetchTagLoading = () => {
    return {
        type : FETCH_TAG_LOADING
    }
}

export const fetchTags = (query = "", page = 1) => {
    return async (dispatch) => {
        dispatch(fetchTagLoading())
        try{
            const res = await apiCall(true, "GET", `/api/tags`)
            dispatch(fetchTagSuccess(res.data))
        }catch(e){
            dispatch(fetchTagError(e))
        } 
    }
}